// extracted by mini-css-extract-plugin
export default {"navMobile":"header_navMobile__v7IhG","navDesktop":"header_navDesktop__kF1eb","destkopMenuList":"header_destkopMenuList__CyKNP"};